import * as actionTypes from "./constants";
import * as Service from "./services";

const getLeaseBuildings = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LEASE_BUILDING_REQUEST });
            const res = await Service.getLeaseBuildings(params);
            if (res && res.status === 200) {
                const floorData = res.data;
                if (floorData.success) {
                    dispatch({
                        type: actionTypes.GET_LEASE_BUILDING_SUCCESS,
                        response: floorData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_LEASE_BUILDING_FAILURE,
                        error: floorData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_LEASE_BUILDING_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LEASE_BUILDING_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const addBuildingLease = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_LEASE_BUILDING_REQUEST });
            const res = await Service.addBuildingLease(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.ADD_LEASE_BUILDING_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.ADD_LEASE_BUILDING_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.ADD_LEASE_BUILDING_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_LEASE_BUILDING_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getLeaseBuildingsById = (lease_id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LEASE_BUILDING_BY_ID_REQUEST });
            const res = await Service.getLeaseBuildingsById(lease_id, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_LEASE_BUILDING_BY_ID_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_LEASE_BUILDING_BY_ID_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_LEASE_BUILDING_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LEASE_BUILDING_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateBuildingLease = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_LEASE_BUILDING_REQUEST });
            const res = await Service.updateBuildingLease(params, id);
            if (res && (res.status === 200 || res.status === 201)) {
                const building_typeData = res.data;
                if (building_typeData.success) {
                    dispatch({
                        type: actionTypes.UPDATE_LEASE_BUILDING_SUCCESS,
                        response: building_typeData
                    });
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_LEASE_BUILDING_FAILURE,
                        error: building_typeData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_LEASE_BUILDING_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_LEASE_BUILDING_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const deleteBuildingLease = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_LEASE_BUILDING_REQUEST });
            const res = await Service.deleteBuildingLease(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.DELETE_LEASE_BUILDING_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({ type: actionTypes.DELETE_LEASE_BUILDING_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_LEASE_BUILDING_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_LEASE_BUILDING_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getLeaseBuildingsDynamicFields = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LEASE_BUILDING_DYNAMIC_FIELDS_REQUEST });
            const res = await Service.getLeaseBuildingsDynamicFields(params);
            if (res && res.status === 200) {
                const floorData = res.data;
                if (floorData.success) {
                    dispatch({
                        type: actionTypes.GET_LEASE_BUILDING_DYNAMIC_FIELDS_SUCCESS,
                        response: floorData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_LEASE_BUILDING_DYNAMIC_FIELDS_FAILURE,
                        error: floorData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_LEASE_BUILDING_DYNAMIC_FIELDS_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LEASE_BUILDING_DYNAMIC_FIELDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const updateLeaseEntityParams = entityParams => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({
                    type: actionTypes.UPDATE_LEASE_ENTITY_PARAMS_SUCCESS,
                    response: entityParams
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_LEASE_ENTITY_PARAMS_FAILURE,
                error: entityParams
            });
        }
    };
};

const getListForCommonFilter = (params, entity) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_COMMON_FILTER_REQUEST });
            const res = await Service.getListForCommonFilter(params, entity);
            if (res && res.status === 200) {
                const floorData = res.data;
                if (floorData.success) {
                    dispatch({
                        type: actionTypes.GET_LIST_FOR_COMMON_FILTER_SUCCESS,
                        response: floorData,
                        entity
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                        error: floorData,
                        entity
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};
const resetReducer = () => ({ type: actionTypes.RESET_REDUCER });


export default {
    getLeaseBuildings,
    updateLeaseEntityParams,
    deleteBuildingLease,
    updateBuildingLease,
    addBuildingLease,
    getLeaseBuildingsById,
    getLeaseBuildingsDynamicFields,
    getListForCommonFilter,
    resetReducer
};
